import { useApi } from 'services';

export const useGeneratePaymentPack = (idOperation) => useApi(
    `v2/operation/${idOperation}/payment-pack`,
    'POST',
    {},
    {}
);

export const usePaymentPackSend = (idOperation) => useApi(
    `v2/operation/${idOperation}/payment-pack/send`,
    'POST',
    {},
    {}
);

export const usePaymentConfigurationForm = (idOperation) => useApi(
    `/quote/payment-pack/form/config/${idOperation}`,
     'GET', 
     {}, 
     {}, 
     true)

export const useFxRates = () => useApi(
    `/currency/fx-rate/`,
     'GET', 
     {}, 
     {}, 
     true)

export const useGeneratePaymentPackStatus = (idOperation) => useApi(
    `/quote/payment-pack/status-generation/${idOperation}`,
     'GET', 
     {}, 
     {}, 
     true)

export const useSavePaymentConfigurationForm = (idOperation) => useApi(
    `/quote/payment-pack/form/config/${idOperation}`,
     'POST', 
     {}, 
     {}, 
     true)

export const useGeneratePaymentPackV2 = () => useApi(
    `/quote/payment-pack`,
     'POST', 
     {}, 
     {}, 
     true)

export const usePaymentPackHtmlModal = (idOperation) => useApi(
    `/quote/payment-pack/${idOperation}`,
    'GET', 
    {}, 
    {}, 
    true)

export const useGetAttachmentsPaymentPack = (idOperation) => useApi(
    `/quote/payment-pack/attachments/list/${idOperation}`,
    'GET', 
    {}, 
    {}, 
    true)    

export const usePaymentPackSendApproval = () => useApi(
    `/quote/payment-pack/approval/send`,
     'POST', 
     {}, 
     {}, 
     true)

export const usePaymentPackListDirectors = (idOperation) => useApi(
    `/quote/payment-pack/approve/list-directors/${idOperation}`,
    'GET', 
    {}, 
    {}, 
    true)

export const useSendPaymantPackToInsurerAndClient = () => useApi(
    `/quote/payment-pack/send/external`,
    'POST', 
    {}, 
    {}, 
    true
)  

export const useSendPaymantPackToInsurerAndClientLegacy = () => useApi(
    `/quote/payment-pack/send/external-legacy`,
    'POST', 
    {}, 
    {}, 
    true
)  

export const useSavePaymentPackContactParties = () => useApi(
    `quote/payment-pack/save-contacts-parties`,
    'POST',
    {},
    {},
    true
)

export const usePaymentSendFramework = () => useApi(
    `/quote/payment-pack/framework/send`,
    'POST', 
    {}, 
    {}, 
    true)

export const useExpirePaymentPack = (idOperation) => useApi(
  `/quote/payment-pack/${idOperation}`,
  'DELETE',
  {},
  {},
  true
);